import React from 'react';

const ActiveDisplay = ({ as = 'div', children, isActive }) => {
  const Component = as;

  return (
    <Component style={{ display: isActive ? 'contents' : 'none' }}>
      {children}
    </Component>
  );
};

export default ActiveDisplay;
